<template>
  <div v-if="!prodotto">
    <div class="d-flex justify-content-center align-items-center box-dual-ring">
      <div class="lds-dual-ring"></div>
    </div>
  </div>
  <div class="menu-space" v-else>
    <div class="container">
      <div class="breadcrumb py-3">
        <a href="/"> {{ "Home" }} </a>
        <span> {{ " / " }} </span>
        <div
          style="text-decoration: underline; cursor: pointer"
          @click="goToPage('')"
        >
          {{ "Collezioni" }}
        </div>
        <span> {{ " / " }} </span>
        <div
          v-if="!prodotto.relSync('accessori').length > 0"
          style="text-decoration: underline; cursor: pointer"
          @click="goToPage('products/' + collezione)"
        >
          <!-- :href="'/collezione/#/products/' + collezione + '?lang=' +schema.lang" -->
          {{ collezione }}
        </div>
        <div
          v-else
          style="text-decoration: underline; cursor: pointer"
          @click="goToPage('accessori/' + collezione)"
        >
          {{ collezione }}
        </div>
        <span> {{ " / " }} </span>
        <p>{{ prodotto.val("nome") }}</p>
      </div>
      <div class="name-subname">
        <div>
          <div class="product-name" style="text-align: start">
            {{ prodotto.val("nome") }}
          </div>
          <div>{{ prodotto.val("descrizione_estesa") }}</div>
        </div>
      </div>
      <div
        v-if="galleria_web && galleria_web.length > 0"
        class="product-slider"
      >
        <div
          class="side-image d-flex justify-content-start align-items-center py-3"
        >
          <div class="side-image-in">
            <swiper
              v-if="prodotto"
              :pagination="{ type: 'fraction' }"
              :navigation="true"
              :modules="modules"
              :slides-per-view="1"
            >
              <swiper-slide v-for="slide in galleria_web" :key="slide.id">
                <div class="swiper-sx">
                  <img
                    class="img-fluid"
                    :src="slide.val('image').link({ x: 1000, ext: 'webp' })"
                    :alt="slide.val('image').name"
                  />
                </div>
                <div class="swiper-dx">
                  <p
                    class="content-slide"
                    v-html="slide.values('contenuto')"
                  ></p>
                </div>
              </swiper-slide>
            </swiper>
          </div>
        </div>
        <div
          class="back-name position-absolute ps-5 d-flex flex-column justify-content-between"
        >
          <div v-if="collezione" class="d-none d-xl-block texture-model">
            {{ collezione }}
          </div>
        </div>
      </div>

      <div
        v-if="disegni_tecnici && disegni_tecnici.length > 0"
        class="tipo-parete d-flex flex-wrap justify-content-center py-5"
      >
        <div class="p-md-5 p-4 d-flex justify-content-center">
          <template v-for="dis in disegni_tecnici" :key="dis.id">
            <div class="px-5 d-flex flex-column justify-content-between">
              <div class="disegni-image mb-">
                <img
                  class="img-fluid"
                  :src="dis.val('disegno').link({ x: 100, ext: 'webp' })"
                />
              </div>
              <div>
                <p class="pt-3 text-center">{{ dis.val("note") }}</p>
              </div>
            </div>
          </template>
        </div>
      </div>

      <div
        v-else
        class="tipo-parete d-flex flex-wrap justify-content-center py-5"
      >
        <div
          class="p-md-5 p-4 d-flex flex-column align-items-center"
          v-for="tp in pareti"
          :key="tp.id"
        >
          <div
            class="d-flex flex-column align-items-center"
            v-if="tp.tipo_parete == 'Parete Doppia'"
          >
            <img src="/icone/parete_doppia.jpg" width="100" />
            <p class="pt-3">{{ tp.tipo_parete }}</p>
          </div>
          <div
            class="d-flex flex-column align-items-center"
            v-else-if="tp.tipo_parete == 'Parete Singola'"
          >
            <img src="/icone/parete_singola.jpg" width="100" />
            <p class="pt-3">{{ tp.tipo_parete }}</p>
          </div>
        </div>
      </div>

      <div style="padding-bottom: 10px" v-if="prodotto.val('descrizione_seo')">
        <div
          v-html="prodotto.val('descrizione_seo')"
          :class="{ expanded: isExpanded }"
          class="leggi-box"
        ></div>
        <div style="padding-top: 10px">
          <button v-if="!isExpanded" @click="toggleExpand" class="leggi-btn">
            {{ trans[schema.lang]["leggi_piu"] }}
          </button>
          <button v-if="isExpanded" @click="toggleExpand" class="leggi-btn">
            {{ trans[schema.lang]["leggi_meno"] }}
          </button>
        </div>
      </div>

      <!-- scheda tecnica -->
      <div
        style="
          display: flex;
          justify-content: flex-end;
          padding: 1em 0;
          border-bottom: 1px solid #dedfd9;
        "
        v-if="prodotto.val('scheda_tecnica')"
      >
        <a
          :href="prodotto.val('scheda_tecnica').link()"
          target="blank"
          class="scheda-tecnica-btn"
          @click="stampaArticolo(articolo)"
          >{{ trans[schema.lang]["scheda_prodotto"] }}
          <img
            class="img-function"
            src="../public/icone/ico_pdf.svg"
            style="width: 20px; padding-left: 4px"
        /></a>
      </div>

      <div class="configura">{{ trans[schema.lang]["config"] }}</div>
      <div>
        <div>
          <p class="subtitle">
            {{ trans[schema.lang]["scegli"] }}
          </p>
        </div>
      </div>
      <div class="tabella-modelli pb-5">
        <table>
          <thead>
            <tr>
              <th></th>
              <th v-if="checkModelsValue('nome')">MOD.</th>
              <th v-if="checkModelsValue('tipo_parete')">TIPO PARETE</th>
              <th v-if="checkModelsValue('codice_base')">COD.BASE</th>
              <th v-if="checkModelsValue('altezza')" class="align-top">
                <div
                  class="d-flex flex-column align-items-center justify-content-start"
                >
                  <img src="/icone/ico_tab01.svg" alt="altezza" width="40" />
                  <span>cm</span>
                </div>
              </th>
              <th
                v-if="checkModelsValue('lunghezza_lato_1_inferiore')"
                class="align-top"
              >
                <div
                  class="d-flex flex-column align-items-center justify-content-start"
                >
                  <img
                    src="/icone/ico_tab02.svg"
                    alt="larghezza base"
                    width="40"
                  />
                  <span>cm</span>
                </div>
              </th>
              <th
                v-if="checkModelsValue('lunghezza_lato_1_superiore_esterno')"
                class="align-top"
              >
                <div
                  class="d-flex flex-column align-items-center justify-content-start"
                >
                  <img
                    src="/icone/ico_tab03.svg"
                    alt="larghezza parte alta"
                    width="40"
                  />
                  <span>cm</span>
                </div>
              </th>
              <th
                v-if="checkModelsValue('lunghezza_lato_1_superiore_interno')"
                class="align-top"
              >
                <div
                  class="d-flex flex-column align-items-center justify-content-start"
                >
                  <img
                    src="/icone/ico_tab04.svg"
                    alt="larghezz aparte alta int"
                    width="40"
                  />
                  <span>cm</span>
                </div>
              </th>
              <th
                v-if="checkModelsValue('profondit_vasca_interna')"
                class="align-top"
              >
                <div
                  class="d-flex flex-column align-items-center justify-content-start"
                >
                  <img src="/icone/ico_tab05.svg" alt="profondità" width="40" />
                  <span>cm</span>
                </div>
              </th>
              <th v-if="checkModelsValue('capacit')" class="align-top">
                <div
                  class="d-flex flex-column align-items-center justify-content-start"
                >
                  <img
                    src="/icone/ico_tab06.svg"
                    alt="capacità"
                    width="40"
                  /><span>lt</span>
                </div>
              </th>
              <th v-if="checkModelsValue()" class="align-top">
                <div
                  class="d-flex flex-column align-items-center justify-content-start"
                >
                  <img src="/icone/ico_tab07.svg" alt="capacità" width="40" />
                  <span class="text-center"
                    >Sottovaso <br />
                    compatibile</span
                  >
                </div>
              </th>
              <th v-if="checkModelsValue('pezzi_per_pallet')" class="align-top">
                <div
                  class="d-flex flex-column align-items-center justify-content-start"
                >
                  <img src="/icone/ico_tab08.svg" alt="packaging" width="40" />
                  <span>pz/plt</span>
                </div>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="mod in modelli" :key="mod.id">
              <th>
                <input @click="setModel(mod)" type="radio" name="check" />
              </th>
              <th v-if="checkModelsValue('nome')">
                {{ mod.val("nome") ? mod.val("nome") : "-" }}
              </th>
              <th v-if="checkModelsValue('tipo_parete')">
                {{ mod.val("tipo_parete") ? mod.val("tipo_parete") : "-" }}
              </th>
              <th v-if="checkModelsValue('codice_base')">
                {{ mod.val("codice_base") ? mod.val("codice_base") : "-" }}
              </th>
              <th v-if="checkModelsValue('altezza')" class="text-center">
                {{ mod.val("altezza") ? mod.val("altezza") : "-" }}
              </th>
              <th
                v-if="checkModelsValue('lunghezza_lato_1_inferiore')"
                class="text-center"
              >
                {{
                  mod.val("lunghezza_lato_1_inferiore")
                    ? mod.val("lunghezza_lato_2_inferiore")
                      ? mod.val("lunghezza_lato_1_inferiore") +
                        "x" +
                        mod.val("lunghezza_lato_2_inferiore")
                      : mod.val("lunghezza_lato_1_inferiore")
                    : "-"
                }}
              </th>
              <th
                v-if="checkModelsValue('lunghezza_lato_1_superiore_esterno')"
                class="text-center"
              >
                {{
                  mod.val("lunghezza_lato_1_superiore_esterno")
                    ? mod.val("lunghezza_lato_2_superiore_esterno")
                      ? mod.val("lunghezza_lato_3_superiore_esterno_profondit")
                        ? mod.val("lunghezza_lato_1_superiore_esterno") +
                          "x" +
                          mod.val("lunghezza_lato_2_superiore_esterno") +
                          "x" +
                          mod.val(
                            "lunghezza_lato_3_superiore_esterno_profondit"
                          )
                        : mod.val("lunghezza_lato_1_superiore_esterno") +
                          "x" +
                          mod.val("lunghezza_lato_2_superiore_esterno")
                      : mod.val("lunghezza_lato_1_superiore_esterno")
                    : "-"
                }}
              </th>
              <th
                v-if="checkModelsValue('lunghezza_lato_1_superiore_interno')"
                class="text-center"
              >
                {{
                  mod.val("lunghezza_lato_1_superiore_interno")
                    ? mod.val("lunghezza_lato_2_superiore_interno")
                      ? mod.val("lunghezza_lato_3_superiore_interno_profondit")
                        ? mod.val("lunghezza_lato_1_superiore_interno") +
                          "x" +
                          mod.val("lunghezza_lato_2_superiore_interno") +
                          "x" +
                          mod.val(
                            "lunghezza_lato_3_superiore_interno_profondit"
                          )
                        : mod.val("lunghezza_lato_1_superiore_interno") +
                          "x" +
                          mod.val("lunghezza_lato_2_superiore_interno")
                      : mod.val("lunghezza_lato_1_superiore_interno")
                    : "-"
                }}
              </th>
              <th
                v-if="checkModelsValue('profondit_vasca_interna')"
                class="text-center"
              >
                {{
                  mod.val("profondit_vasca_interna")
                    ? mod.val("profondit_vasca_interna")
                    : "-"
                }}
              </th>
              <th v-if="checkModelsValue('capacit')" class="text-center">
                {{ mod.val("capacit") ? mod.val("capacit") : "-" }}
              </th>
              <th v-if="checkModelsValue()" class="text-center">
                {{ mod.sottovaso ? mod.sottovaso : "-" }}
              </th>
              <th
                v-if="checkModelsValue('pezzi_per_pallet')"
                class="text-center"
              >
                {{
                  mod.val("pezzi_per_pallet")
                    ? mod.val("pezzi_per_pallet")
                    : "-"
                }}
              </th>
            </tr>
          </tbody>
        </table>
      </div>
      <div v-if="colori">
        <div>{{ trans[schema.lang]["colori"] }}</div>
        <div class="colori pb-5">
          <div
            v-for="colore in colori"
            :key="colore.id"
            @click="selectColor(colore)"
            class="color-box"
            :class="{
              'color-active': selected_color
                ? selected_color.id == colore.id
                : false,
              'color-opacity': selected_color
                ? selected_color.id != colore.id
                : false,
              'color-block': colori_disable,
            }"
          >
            <div class="square">
              <div class="square-content">
                <img
                  v-if="colore.val('image')"
                  :src="
                    colore.val('image').link({ x: '200', y: '200', ext: 'png' })
                  "
                  style="max-width: 100%; width: 100%"
                  :alt="colore.val('image').name"
                />
              </div>
            </div>
            <div class="prod-name">{{ colore.val("nome") }}</div>
          </div>
        </div>
      </div>
      <div v-if="articolo" class="box-articolo-info pb-5 d-flex flex-column">
        <div class="freccia pb-5 d-flex justify-content-center">
          <img src="/icone/freccia_prodotto.jpg" alt="" />
        </div>
        <div class="box-image-dati d-flex">
          <div class="image-articolo d-flex">
            <img
              v-if="articolo.val('image')"
              class="img-fluid"
              :src="articolo.val('image').link({ x: 200, ext: 'webp' })"
              alt=""
            />
            <img
              v-else-if="
                !articolo.val('image') && prodotto.val('immagine_scala_grigi')
              "
              class="img-fluid"
              :src="
                prodotto
                  .val('immagine_scala_grigi')
                  .link({ x: 200, ext: 'webp' })
              "
              alt=""
            />
            <img
              v-else
              :src="selected_color.val('image').link({ x: 200, ext: 'webp' })"
              alt=""
            />

            <img
              v-if="
                prodotto.val('immagine_scala_grigi') && !articolo.val('image')
              "
              :src="selected_color.val('image').link({ x: 150, ext: 'webp' })"
              alt=""
              class="ps-4"
            />
          </div>
          <div class="articolo-box ps-lg-4 pt-lg-0 pt-4">
            <div>
              {{ modello_selected.val("nome") }} -
              {{ modello_selected.val("tipo_parete") }} -
              {{ selected_color.val("nome") }}
              <!-- {{modello_selected.relSync('prodotti')[0].val('scheda_tecnica').link()}} -->
            </div>
            <div>
              COD:
              <span id="art_code_color" style="font-weight: bold">{{
                articolo.val("codice_esploso") + text_drenaggio
              }}</span>
            </div>
            <!-- DRENAGGIO-------------------------
            {{text_drenaggio}} -->
            <!-- {{articolo.val("codice_esploso")}} -->
            <div class="recap-info d-flex flex-wrap pt-4">
              <div v-if="modello_selected.val('altezza')" class="py-3">
                <img src="/icone/ico_tab01.svg" alt="altezza" width="50" />
                <p>
                  {{
                    modello_selected.val("altezza")
                      ? modello_selected.val("altezza")
                      : "-"
                  }}
                </p>
              </div>
              <div
                v-if="modello_selected.val('lunghezza_lato_1_inferiore')"
                class="py-3"
              >
                <img
                  src="/icone/ico_tab02.svg"
                  alt="larghezza base"
                  width="50"
                />
                <p>
                  {{
                    modello_selected.val("lunghezza_lato_1_inferiore")
                      ? modello_selected.val("lunghezza_lato_1_inferiore")
                      : "-"
                  }}
                </p>
              </div>
              <div
                v-if="
                  modello_selected.val('lunghezza_lato_1_superiore_esterno')
                "
                class="py-3"
              >
                <img
                  src="/icone/ico_tab03.svg"
                  alt="larghezza parte alta"
                  width="50"
                />
                <p>
                  {{
                    modello_selected.val("lunghezza_lato_1_superiore_esterno")
                      ? modello_selected.val(
                          "lunghezza_lato_2_superiore_esterno"
                        )
                        ? modello_selected.val(
                            "lunghezza_lato_3_superiore_esterno_profondit"
                          )
                          ? modello_selected.val(
                              "lunghezza_lato_1_superiore_esterno"
                            ) +
                            "x" +
                            modello_selected.val(
                              "lunghezza_lato_2_superiore_esterno"
                            ) +
                            "x" +
                            modello_selected.val(
                              "lunghezza_lato_3_superiore_esterno_profondit"
                            )
                          : modello_selected.val(
                              "lunghezza_lato_1_superiore_esterno"
                            ) +
                            "x" +
                            modello_selected.val(
                              "lunghezza_lato_2_superiore_esterno"
                            )
                        : modello_selected.val(
                            "lunghezza_lato_1_superiore_esterno"
                          )
                      : "-"
                  }}
                </p>
              </div>
              <div
                v-if="
                  modello_selected.val('lunghezza_lato_1_superiore_interno')
                "
                class="py-3"
              >
                <img
                  src="/icone/ico_tab04.svg"
                  alt="larghezz aparte alta int"
                  width="50"
                />
                <p>
                  {{
                    modello_selected.val("lunghezza_lato_1_superiore_interno")
                      ? modello_selected.val(
                          "lunghezza_lato_2_superiore_interno"
                        )
                        ? modello_selected.val(
                            "lunghezza_lato_3_superiore_interno_profondit"
                          )
                          ? modello_selected.val(
                              "lunghezza_lato_1_superiore_interno"
                            ) +
                            "x" +
                            modello_selected.val(
                              "lunghezza_lato_2_superiore_interno"
                            ) +
                            "x" +
                            modello_selected.val(
                              "lunghezza_lato_3_superiore_interno_profondit"
                            )
                          : modello_selected.val(
                              "lunghezza_lato_1_superiore_interno"
                            ) +
                            "x" +
                            modello_selected.val(
                              "lunghezza_lato_2_superiore_interno"
                            )
                        : modello_selected.val(
                            "lunghezza_lato_1_superiore_interno"
                          )
                      : "-"
                  }}
                </p>
              </div>
              <div
                v-if="modello_selected.val('profondit_vasca_interna')"
                class="py-3"
              >
                <img src="/icone/ico_tab05.svg" alt="profondità" width="50" />
                <p>
                  {{
                    modello_selected.val("profondit_vasca_interna")
                      ? modello_selected.val("profondit_vasca_interna")
                      : "-"
                  }}
                </p>
              </div>
              <div v-if="modello_selected.val('capacit')" class="py-3">
                <img src="/icone/ico_tab06.svg" alt="capacità" width="50" />
                <p>
                  {{
                    modello_selected.val("capacit")
                      ? modello_selected.val("capacit")
                      : "-"
                  }}
                </p>
              </div>
              <div v-if="modello_selected.sottovaso" class="py-3">
                <img src="/icone/ico_tab07.svg" alt="capacità" width="50" />
                <p>
                  {{
                    modello_selected.sottovaso
                      ? modello_selected.sottovaso
                      : "-"
                  }}
                </p>
              </div>
              <div v-if="modello_selected.val('pezzi_per_pallet')" class="py-3">
                <img src="/icone/ico_tab08.svg" alt="packaging" width="50" />
                <p>
                  {{
                    modello_selected.val("pezzi_per_pallet")
                      ? modello_selected.val("pezzi_per_pallet")
                      : "-"
                  }}
                </p>
              </div>
            </div>
            <div>
              <div style="display: flex">
                {{ articolo.val("scheda_tecnica") }}
                <ContextPopUp></ContextPopUp>
                <!-- <div style="display:flex; flex-direction:row; align-items:center; justify-content:center; padding:5px 15px; cursor:pointer"><img class="img-function" src="share.png" > -->
                <!-- </div> -->
                <div
                  style="
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                    justify-content: center;
                    padding: 5px 15px;
                    cursor: pointer;
                    border: 1px solid #000;
                  "
                  @click="aggiungiAlCarrello(articolo, true, false)"
                >
                  {{ trans[schema.lang]["aggiungi_carrello"] }}
                  <img class="img-function" src="../public/icone/shop.png" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="modelli_accessori && modelli_accessori.length > 0">
          <!-- {{modelli_accessori.rel('')}} -->
          <div class="title-accessori pt-5 pb-3">
            {{ trans[schema.lang]["accessori"] }}
          </div>
          <div class="box-accessori d-flex flex-wrap">
            <!-- <div v-for="art__ in modelli_accessori_articoli" :key="art__" class="col-4"> -->
            <div
              v-for="accessorio in modelli_accessori"
              :key="accessorio.id"
              class="accessorio py-4 pe-lg-4 pe-0 d-flex"
            >
              <!-- {{ accessorio.relSync('articoli') }} -->
              <div style="width: 100%; display: flex" class="row">
                <div
                  v-for="acc in accessorio.relSync('articoli')"
                  :key="acc"
                  class="col-12 col-sm-12 col-md-12 col-lg-4 py-3"
                  style="border: 1px solid #f1f1f1"
                >
                  <div
                    @click="
                      goToPage('accessori/' + clearParams(accessorio.cat))
                    "
                    style="font-size: 12px; text-decoration: underline"
                  >
                    {{ accessorio.cat }}
                  </div>
                  <p>{{ accessorio.val("nome") }}</p>
                  <div class="d-flex lista-accessori">
                    <div
                      class="box-accessorio-image col-4 col-md-4 col-sm-12 col-lg-12"
                    >
                      <img
                        v-if="accessorio.val('image')"
                        class="img-fluid"
                        :src="accessorio.val('image').link()"
                        alt=""
                        style="max-width: 300px"
                      />
                      <img
                        v-else
                        class="img-fluid"
                        src="collezioni/placeholder.png"
                        alt=""
                      />
                    </div>
                    <div
                      class="box-accessorio-table col-8 col-md-8 col-sm-12 col-lg-12 px-lg-3 ps-0 pt-xl-0 pt-3"
                    >
                      <div v-if="accessorio.val('nome') != 'Foro di drenaggio'">
                        <table>
                          <thead>
                            <tr>
                              <th>MOD.</th>
                              <th>COD.BASE</th>
                              <!-- {{accessorio_colorato.}} -->
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <th>{{ accessorio.val("nome") }}</th>
                              <th>{{ accessorio.val("codice_base") }}</th>
                            </tr>
                          </tbody>
                        </table>
                        <table
                          v-if="
                            accessorio.val('altezza') ||
                            accessorio.val(
                              'lunghezza_lato_1_superiore_esterno'
                            ) ||
                            accessorio.val('lunghezza_lato_1_superiore_interno')
                          "
                        >
                          <thead class="misure-tab-accessorio">
                            <tr>
                              <th style="width: calc(100% / 3)">
                                <img
                                  src="/icone/ico_tab01.svg"
                                  alt=""
                                  width="30"
                                />
                                <span>cm</span>
                              </th>
                              <th style="width: calc(100% / 3)">
                                <img
                                  src="/icone/ico_tab03.svg"
                                  alt=""
                                  width="30"
                                />
                                <span>cm</span>
                              </th>
                              <th style="width: calc(100% / 3)">
                                <img
                                  src="/icone/ico_tab04.svg"
                                  alt=""
                                  width="30"
                                />
                                <span>cm</span>
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <th style="background-color: #fff">
                                {{
                                  accessorio.val("altezza")
                                    ? accessorio.val("altezza")
                                    : "-"
                                }}
                              </th>
                              <th style="background-color: #fff">
                                {{
                                  accessorio.val(
                                    "lunghezza_lato_1_superiore_esterno"
                                  )
                                    ? accessorio.val(
                                        "lunghezza_lato_1_superiore_esterno"
                                      )
                                    : "-"
                                }}
                              </th>
                              <th style="background-color: #fff">
                                {{
                                  accessorio.val(
                                    "lunghezza_lato_1_superiore_interno"
                                  )
                                    ? accessorio.val(
                                        "lunghezza_lato_1_superiore_interno"
                                      )
                                    : "-"
                                }}
                              </th>
                            </tr>
                          </tbody>
                        </table>
                        <table>
                          <tbody>
                            <!-- Includi nel carrello -->
                            <tr>
                              <!-- <th> 
                                <input  class="align-middle"
                                        id=""
                                        type="checkbox"
                                        name=""
                                        >
                              </th> -->
                              <!-- <th class="text-uppercase"> AGGIUNGI AL CARRELLO </th> -->
                            </tr>
                          </tbody>
                        </table>
                        <div style="padding-top: 10px">
                          {{ trans[schema.lang]["colore"] }} :{{
                            acc?.relSync("colori")[0]?.val("nome")
                          }}
                          <img
                            v-if="acc?.relSync('colori')[0]?.val('image')"
                            class="img-fluid"
                            style="max-width: 40px"
                            :src="
                              acc
                                ?.relSync('colori')[0]
                                ?.val('image')
                                .link({ x: 200, ext: 'webp' })
                            "
                            alt=""
                          />
                        </div>
                        <!-- <div style="padding-top:10px;">
                        </div> -->
                        <div style="display: flex; padding-top: 20px">
                          <div
                            style="
                              display: flex;
                              flex-direction: row;
                              align-items: center;
                              justify-content: center;
                              padding: 5px 15px;
                              cursor: pointer;
                              border: 1px solid #000;
                            "
                            @click="aggiungiAlCarrello(accessorio, false, acc)"
                          >
                            {{ trans[schema.lang]["aggiungi_carrello"] }}
                            <img
                              class="img-function"
                              src="../public/icone/shop.png"
                            />
                          </div>
                        </div>
                      </div>

                      <div v-else class="foro-drenaggio">
                        <p>
                          {{ trans[schema.lang]["foro_info"] }}
                        </p>
                        <table>
                          <tbody>
                            <!-- Includi foro al nome -->
                            <tr>
                              <!-- <th> 
                                <input  class="class=align-middle"
                                        id="check_drenaggio"
                                        type="checkbox"
                                        name="drenaggio"
                                        @click="select_foro_drenaggio()"> 
                              </th> -->
                              <!-- <th class="text-uppercase"> AGGIUNGI AL CARRELLO </th> -->
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- </div> -->
          </div>
          <!-- <div v-if="accessorio_sottovaso" class="sottovasi-piastre p-3">
            <a href="#">Vai alla sezione Sottovasi <img src="../public/icone/freccia_prodotti.svg" alt="" style="width: 30px;" class="ms-2"></a>
          </div>
          <div v-if="accessorio_piastra" class="sottovasi-piastre p-3">
            <a href="#">Vai alla sezione piastre di ancoraggio <img src="../public/icone/freccia_prodotti.svg" alt="" style="width: 30px;" class="ms-2"></a>
          </div> -->
        </div>
        <div v-if="kit_illuminabili.length > 0">
          <div class="title-accessori pt-5 pb-3">
            {{ trans[schema.lang]["kit"] }}
          </div>
          <div class="d-flex flex-wrap">
            <template v-for="kit in kit_illuminabili" :key="kit.id">
              <div class="box-illuminabile">
                <img
                  class="img-fluid"
                  v-if="kit.val('image')"
                  :src="kit.val('image').link()"
                  alt=""
                />
                <img
                  class="img-fluid"
                  v-else
                  src="/collezioni/placeholder.png"
                  alt=""
                />
                <div>{{ kit.val("nome") }}</div>
              </div>
            </template>
          </div>
        </div>
      </div>
      <!-- <a class="local-storage-button" @click="addToLocalStorage()">Aggiungi al carrello</a> -->
      <div
        v-if="
          prodotto &&
          prodotto.relSync('prodotti_consigliati') &&
          prodotto.relSync('prodotti_consigliati').length > 0
        "
      >
        <div class="prodotti-correlati pt-5 pb-3 mb-4">
          {{ trans[schema.lang]["consigliati"] }}
        </div>
        <div class="d-flex flex-wrap">
          <div
            v-for="prd_cons in prodotto.relSync('prodotti_consigliati')"
            :key="prd_cons.id"
            class="case-image p-2"
          >
            <!-- @click="goToPage('' + $router.resolve({name: 'prodotto',params: { prodotto: prd_cons.val('nome') },}).href)" -->
            <div
              style="text-decoration: none; color: #000"
              class="prod-href"
              @click="
                refreshArticles();
                goToPage(
                  '' +
                    $router.resolve({
                      name: 'prodotto',
                      params: { prodotto: prd_cons.val('nome') },
                    }).href
                );
              "
            >
              <div>
                <div>
                  <img
                    v-if="prd_cons.val('image')"
                    class="img-fluid"
                    :src="
                      prd_cons.val('image').link({ x: 400, y: 400, ext: 'jpg' })
                    "
                    :alt="prd_cons.val('nome')"
                  />
                  <img
                    v-else
                    class="img-fluid"
                    src="/collezioni/placeholder.png"
                    alt="placeholder"
                  />
                  <div class="prod-name">{{ prd_cons.val("nome") }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <NotificationPopUp
      :message="notificationMessage"
      :visible="notificationVisibility"
    ></NotificationPopUp>
  </div>
</template>

<script lang="js">
// import { defineComponent } from "@vue/runtime-core";
import { Schema } from "onpage-js";
import { Swiper,SwiperSlide } from "swiper/vue";
import { Navigation, Pagination } from "swiper";
import NotificationPopUp from "./components/NotificationPopUp.vue";
import ContextPopUp from "./components/ContextPopUp.vue";
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';

export default{
  components: {
      Swiper,
      SwiperSlide,
      NotificationPopUp,
      ContextPopUp,
  },
  props: {
    schema: {
      type: Schema,
      required: true,
    },
  },
  setup(){
    return {
      modules: [Navigation,Pagination],
    };
  },
  mounted() {
    window.document.getElementById('app').scrollIntoView()
    if(this.schema.lang == 'en'){
      this.notificationMessage= 'Product added to cart'
    } else {
      this.notificationMessage= 'Prodotto aggiunto al carrello'
    }
  },
  data() {
    return {
      accessorio_colorato: null,
      notificationVisibility: false,
      notificationMessage: 'Prodotto aggiunto al carrello',
      prodotto: null,
      disegni_tecnici: null,
      modelli: null,
      accessori: null,
      modelli_accessori: null,
      modelli_accessori_articoli: null,
      prod_consigliati: null,
      kit_illuminabili: null,
      galleria_web: null,
      description_gallery: null,
      tipo_pareti: null,
      pareti: null,
      modello_selected: null,
      articoli: null,
      colori: null,
      selected_color: null,
      articolo: null,
      foro_drenaggio: null,
      gallery_swiper: null,
      value_drenaggio: false,
      text_drenaggio: "",
      accessorio_sottovaso: null,
      accessorio_piastra: null,
      colori_disable: true,
      isExpanded: false,
      trans: {
        'it': {
          config: "CONFIGURA IL TUO MODELLO",
          scegli: "SCEGLI IL MODELLO IN BASE ALLA TIPOLOGIA DI PARETE E ALLA LARGHEZZA",
          colori: "SCEGLI TRA I COLORI DISPONIBILI",
          consigliati: "PRODOTTI CONSIGLIATI",
          accessori: "ACCESSORI",
          foro_info: "Disponibile su richiesta solo nella versione a doppia parete. La canalina di drenaggio è stata appositamente studiata per defluire l’acqua in eccesso verso il foro di uscita posto sulla parete laterale inferiore del vaso.",
          kit: "KIT ILLUMINABILI",
          scheda_prodotto: 'SCHEDA PRODOTTO',
          aggiungi_carrello: 'AGGIUNGI AL CARRELLO',
          condividi: 'Condividi',
          colore: 'Colore',
          leggi_piu: "Leggi di più",
          leggi_meno: "Leggi meno",
        },
        'en': {
          config: "CONFIGURE YOUR MODEL",
          scegli: "CHOOSE THE MODEL ACCORDING TO THE TYPE OF WALL AND WIDTH",
          colori: "CHOOSE FROM AVAILABLE COLOURS",
          consigliati: "RECOMMENDED PRODUCTS",
          accessori: "ACCESSORIES",
          foro_info: "Available on request only in the double-wall version. The drainage channel is specially designed to drain excess water to the outlet hole on the lower side wall of the toilet.",
          kit: "ILLUMINABLE KITS",
          scheda_prodotto: 'DATA SHEET',
          aggiungi_carrello: 'ADD TO CART',
          condividi: 'Share',
          colore: 'Color',
          leggi_piu: "Read more",
          leggi_meno: "Read less",
        }
      }
    };
  },
  async created() {
    this.refreshSezioni()
  },
  computed: {
    prodotti_query(){
      const schema = this.schema;
      if (!schema) return;
      const q = schema
        .query("prodotti")
        .with("sezioni.collezioni", "galleria_web")
        .with("accessori")
        .with("prodotti_consigliati")
        .with("disegni_tecnici")
        .with("modelli.modelli_accessori.articoli")
        .with("modelli.modelli_accessori.articoli.colori")
        .where("nome", this.resolve(this.$route.params.prodotto));
      return q;
    },
    articles_query(){
      const schema = this.schema;
      if (!schema) return;
        const q = schema
        .query("articoli")
        .where("modelli._id", this.modello_selected.id)
        .with("colori").with("accessori_per_illuminabili");
        return q;
    },
    sezione() {
      if(!this.prodotto) return null;
      if(this.prodotto.relSync("sezioni").length==0) return null;
      return this.prodotto.relSync("sezioni")[0];
    },
    collezione() {
      if(this.sezione){
        if(this.sezione.relSync("collezioni").length>0 && this.sezione.relSync("collezioni")[0]){
          return this.sezione.relSync("collezioni")[0].val("nome");
        } else {
        return null
        }
      } else {
        if(this.prodotto.relSync('accessori').length>0 && this.prodotto.relSync('accessori')[0]){
          return this.prodotto.relSync('accessori')[0].val('nome');
        } else {
          return null
        }
      }
    },
  },
  methods: {
    toggleExpand() {
      this.isExpanded = !this.isExpanded;
    },
    aggiungiAlCarrello(articolo, isArticolo, sotto_articolo) {
      // Preleva carrello attuale
      let currentCarrello = [];
      if (localStorage.getItem('cart_items')) {
        currentCarrello = JSON.parse(localStorage.getItem('cart_items'));
      }
      console.log('colore selezionato', this.selected_color.val('image').link())
      console.log('colore selezionato', this.selected_color)

      // if(this.selected_color != ''){

      // }

      let immagine_livello_superiore= ""
      if(isArticolo && this.galleria_web[0]){
        immagine_livello_superiore = this.galleria_web[0].val('image').link()
      } else {
        immagine_livello_superiore = articolo?.val('image')?.link()
      }




      // -------------------------------------
      console.log('---- test dati ----', articolo)
      console.log('---- test codice base----', articolo.val('codice_base'))
      // if(this.selected_color){
      //   // modelli_accessori =
      //   for (let index = 0; index < this.modelli_accessori_articoli.length; index++) {
      //     const element = this.modelli_accessori_articoli[index];
      //     // console.log(element)
      //     console.log('codice esploso ---', element.val('codice_esploso'))
      //     console.log('codice esploso --- paragone --------', articolo.val('codice_base') + ' 0' + this.selected_color.val('suffisso_colore'))
      //     // console.log('art value ------------', articolo.val('codice_base'))
      //     // consol.log('------------ ', this.modello_selected.val('codice_base'))
      //     // console.log(this.articolo.val('codice_esploso') + ' ' + this.selected_color.val('suffisso_colore'))
      //     // console.log(this.articolo.val('codice_esploso'))
      //     // console.log('--------------', this.modello_selected.val('codice_base'));
      //     // console.log('@@@@@@@@@@@@@@@@ò', this.modelli_accessori_articoli[0].val('codice_esploso'));
      //     console.log('#####################à', this.selected_color.val('suffisso_colore'))
      //     // console.log('______________-', element.val('codice_esploso').split(' ')[0])
      //     if(this.selected_color.val('suffisso_colore')){
      //       if(element.val('codice_esploso') == articolo.val('codice_base') + ' 0' + this.selected_color.val('suffisso_colore')
      //       || element.val('codice_esploso') == articolo.val('codice_base') + ' ' + this.selected_color.val('suffisso_colore')  ){
      //         console.log('trovatooooooooooooooooo')
      //         // console.log(element)
      //         this.accessorio_colorato = element
      //         // modelli_accessori
      //       } else if(!this.accessorio_colorato){
      //         if(element.val('codice_esploso') == articolo.val('codice_base')){
      //         console.log('trovatooooooooooooooooo 22222')
      //         // console.log(element)
      //         this.accessorio_colorato = element
      //         // modelli_accessori
      //       }
      //       }
      //     } else {
      //       if(element.val('codice_esploso') == articolo.val('codice_esploso')){
      //         // console.log('-----trovatooooooooooooooooo -----------')
      //         // console.log(element)
      //         this.accessorio_colorato = element
      //         // modelli_accessori
      //       }
      //     }

      //   }
      // } else {
      //   this.accessorio_colorato = null
      // }
      // // -------------------------------------

      // if(!isArticolo && this.accessorio_colorato){
      //   console.log('ID----', articolo.id)
      //   console.log('accessorio_col ', this.accessorio_colorato)
      //   articolo = this.accessorio_colorato
      //   console.log('ID----', articolo.id)
      //   // console.log('accessorio_col ', this.accessorio_colorato)
      // }
      // Verifica se l'articolo esiste già nel carrello
        if(sotto_articolo){
          articolo = sotto_articolo
        }


      const existingProductIndex = currentCarrello.findIndex(item => item.article_id === articolo.id);

      // Se l'articolo esiste, aumenta la quantità
      if (existingProductIndex >= 0) {
        currentCarrello[existingProductIndex].quantity += 1;
      } else {
        // Se l'articolo non esiste, aggiungilo al carrello
        let product_object_cart
        if(isArticolo){
          product_object_cart = {
            quantity: 1,
            article_id: articolo.id,
            note: '',
            image: immagine_livello_superiore,
            colore: this.selected_color?.val("nome"),
            colore_image: this.selected_color?.val('image')?.link({ ext: 'webp' }),
            suffisso_colore: this.selected_color?.val("suffisso_colore"),

          };
        } else {
          let asd
          if(sotto_articolo && sotto_articolo.relSync('colori')){
            asd = sotto_articolo.relSync('colori')[0]
          }
          console.log('articolooooooo---', articolo)
          console.log('coloreeeeee---', sotto_articolo.relSync('colori')[0])
          // console.log('val---', asd?.val('suffisso_colore'))
          console.log('articolooooooo---', sotto_articolo)

          product_object_cart = {
            quantity: 1,
            article_id: sotto_articolo.id,
            note: '',
            image: immagine_livello_superiore,
            colore: asd ? asd?.val("nome") : '',
            colore_image: asd ? asd?.val('image')?.link({ ext: 'webp' }) : '',
            suffisso_colore: asd ? asd?.val('suffisso_colore'): '',

          };
        }

        // console.log('articolo-------------------', articolo)
        // console.log('accessorio colorato-------------------', this.accessorio_colorato)
        // console.log('NUMERO-------------------', this.accessorio_colorato.val('codice_esploso').split(' ').length)
        // if(this.accessorio_colorato && (this.accessorio_colorato.val('codice_esploso').split(' ')).length == 1 && !isArticolo){
        //   product_object_cart.colore = ''
        //   product_object_cart.colore_image = ''
        //   product_object_cart.suffisso_colore = ''
        // }
        // if(this.accessorio_colorato){
        // }

        currentCarrello.push(product_object_cart);
        console.log('carrelllooooo',currentCarrello);
      }

      console.log(currentCarrello)
      this.notificationVisibility = true;
      setTimeout(() => {
        this.notificationVisibility = false;
      }, 1500); // il popup scomparirà dopo 3 secondi

      // Aggiorna il carrello nel localStorage
      localStorage.setItem('cart_items', JSON.stringify(currentCarrello));
    },
    stampaArticolo(articolo){
      console.log(articolo)
    },
    goToPage(path) {
      console.log(path)
      this.$router.push({ path: `/${path.replace('#/', '')}` })
    },
    async refreshSezioni() {
      this.prodotto = await this.prodotti_query.first();
      //console.log(this.prodotto);
      this.modelli =  this.prodotto.relSync("modelli");


      console.log("finwoifnw")
      this.setModel(this.modelli[0])
      this.colori_disable = true

      this.modelli.forEach(mod => {
        let sottovaso = mod.relSync("modelli_accessori").filter(x => x.val("sottovaso"))
        if(sottovaso.length>0){
          mod.sottovaso = sottovaso[0].val("nome")
        }
      });

      console.log(this.modelli)

      this.galleria_web = await this.prodotto.rel("galleria_web");
      this.tipo_parete = this.modelli.map((x) => x.val("tipo_parete"));
      this.tipo_parete = [...new Set(this.tipo_parete)];
      this.disegni_tecnici = this.prodotto.relSync("disegni_tecnici");
      console.log("disegni",this.disegni_tecnici)
      let pareti = [];
      this.tipo_parete.forEach((element) => {
        let obj = {};
        obj.tipo_parete = element;
        obj.modelli = this.modelli.filter(
          (x) => x.val("tipo_parete") == element
        );
        pareti.push(obj);
      });
      this.pareti = pareti;
    },
    async refreshArticles() {
      this.articoli = await this.articles_query.all();
      this.colori = [];
      this.articoli.forEach((art) => {
        art.relSync("colori").forEach((colore) => {
          this.colori.push(colore);
        });
      });
      console.log('modello, ' , this.modello_selected)
      this.modelli_accessori = await this.modello_selected.rel("modelli_accessori");

      this.modelli_accessori_articoli = await this.modello_selected.rel("modelli_accessori.articoli");
      // console.log(modelli_accessori_articoli)



      console.log('modelli accessori', this.modelli_accessori)
      console.log('modelli accessori articoli', this.modelli_accessori_articoli)
      // console.log('modelli accessori articoli colori', this.modelli_accessori_articoli[0].relSync('colori'))



      this.modelli_accessori.forEach(async element => {
        let relation = await element.rel('prodotti.accessori')
        if(relation.length>0){
          element.cat = relation[0].val("nome")
        }
      });
      this.findTipoAccessorio();
    },
    setModel(modello) {
      this.modello_selected = modello;
      this.colori_disable = false;
      this.articolo = null;
      this.selected_color = null;
    },
    selectColor(colore) {
      if(!this.colori_disable){
        this.selected_color = colore;
        // this.refreshSezioni();
        this.refreshArticles();
      }
    },
    takeLightKit(){
      if(this.selected_color){
        let accessorio = this.selected_color.relSync('articoli')[0];
        this.kit_illuminabili = accessorio.relSync('accessori_per_illuminabili');
        //console.log(this.kit_illuminabili)
      }
    },
    select_foro_drenaggio(){
      if(this.value_drenaggio == false){
        this.value_drenaggio = true;
        this.text_drenaggio = " - Con foro di drenaggio"
      }else{
        this.value_drenaggio = false;
        this.text_drenaggio = "";
      }

    },
    findTipoAccessorio(){
      this.accessorio_piastra = null;
      this.accessorio_sottovaso = null;
      this.modelli_accessori.forEach(mod =>{
        if(mod.val('sottovaso') && this.accessorio_sottovaso == null){
            this.accessorio_sottovaso = true;
            //console.log("sottovaso: ", this.accessorio_sottovaso)
        }
        if(mod.val('piastra') && this.accessorio_piastra == null){
          this.accessorio_piastra = true;
            //console.log("piastra: ", this.accessorio_piastra)
        }
      })
    },
    cleanColor(){
      this.color = []
    },
    clearParams(nome){
      return nome.replaceAll("/","-").replaceAll(" ","_");
    },
    resolve(param){
      return param.replaceAll("-","/").replaceAll("_"," ");
    },
    checkModelsValue(valore = null){
      let check = false;
      if(valore){
          this.modelli.forEach(mod=>{
          if(mod.val(valore)) check = true
        })
      } else {
        this.modelli.forEach(mod=>{
          if(Object.prototype.hasOwnProperty.call(mod, 'sottovaso')) check = true
      })
    }
    return check;
    },
    addToLocalStorage(){
      let items = [{
        'item_key': this.articolo && this.modello_selected ? this.articolo.id+this.modello_selected.id : null,
        'mod': this.modello_selected ? this.modello_selected.val('nome') : null,
        'parete': this.modello_selected ? this.modello_selected.val('tipo_parete') : null,
        'art': this.articolo ? this.articolo.val('codice_esploso') + this.text_drenaggio : null,
        'art_img': this.articolo.val('image') ? this.articolo.image('image').link() : null,
        'color': this.selected_color ? this.selected_color.val('nome') : null,
      }];
      localStorage.setItem(localStorage.length,JSON.stringify(items))
    }
  },
  watch: {
    modello_selected() {
      if (this.modello_selected) {
        this.refreshArticles();
      }
    },
    selected_color() {
      if (this.selected_color) {
        this.articolo = this.articoli.filter((art) => {
          let presente = false;
          art.relSync("colori").forEach((colore) => {
            if (colore.id == this.selected_color.id) {
              presente = true;
            }
          });
          if (presente) {
            return true;
          }
        })[0];
      }
      this.takeLightKit();
    },
    "$route.params.prodotto"(){
      window.scrollTo(0,0);
      this.refreshSezioni();
    },
  },
};
</script>

<style>
.texture-model {
  font-weight: 100;
  font-size: 250px;
  line-height: 250px;
  position: absolute;
  z-index: -5;
  top: 0;
  left: -30px;
  color: #eaebe7;
}
.back-name {
  position: absolute;
  top: 0;
  left: 60%;
}
.side-image {
  width: 100%;
}
.product-slider {
  position: relative;
}
.side-image-in {
  width: 100%;
}
.swiper-slide {
  width: 100%;
  display: flex;
  justify-content: end;
}
.swiper-slide img {
  height: 700px;
  object-fit: contain;
}
.swiper-sx {
  width: 60%;
  display: flex;
  justify-content: end;
  padding: 20px 0;
  border-top: 1px solid #636363;
  border-bottom: 1px solid #636363;
}
.swiper-dx {
  width: 40%;
  display: flex;
  align-items: center;
}
.content-slide {
  position: absolute;
  left: 70%;
}
.swiper-pagination {
  position: absolute;
  left: 35%;
  top: 93.5%;
  display: inline-block;
  z-index: -5;
}
.swiper-button-next,
.swiper-button-prev {
  width: 60px;
  background-image: url(../public/icone/freccia_prodotti.svg);
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
}
.swiper-button-prev {
  transform: rotate(180deg);
  left: 70%;
}
.swiper-button-next::after,
.swiper-button-prev::after {
  content: "";
}
.swiper-button-next,
.swiper-button-prev {
  color: #a8716c;
  top: 95%;
}
.case-image {
  width: calc(100% / 5);
  transition: all 0.2s linear;
}
.case-image:hover {
  transform: scale(1.04);
}
.prodotti-correlati {
  border-bottom: 1px solid #dedfd9;
}
.name-subname {
  width: 100%;
  display: flex;
  justify-content: end;
}
.product-name {
  font-size: 32px;
  text-transform: uppercase;
  text-align: end;
}
.tipo-parete p {
  text-transform: uppercase;
}
.scheda-tecnica-btn {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 15px 18px;
  cursor: pointer;
  text-decoration: none;
  color: inherit;
  border: 1px solid #b3b2b2;
  border-radius: 10px;
  background: rgb(255, 255, 255);
  background: linear-gradient(
    180deg,
    rgba(255, 255, 255, 1) 0%,
    rgba(198, 198, 198, 1) 100%
  );
  transition: all 0.3s;
}
.scheda-tecnica-btn:hover {
  color: #000;
  background: #fff;
}
.configura {
  display: flex;
  justify-content: center;
  padding: 1em 1em 1em 1em;
  font-size: 32px;
}
.subtitle,
.sottovasi-piastre a {
  font-size: 1em;
  font-weight: 600;
  color: #646363;
}
.sottovasi-piastre a {
  text-decoration: none;
}
.sottovasi-piastre a:hover {
  text-decoration: underline;
}
table {
  width: 100%;
}
table th {
  border: none !important;
}
.tabella-modelli table th {
  padding: 10px;
}
.tabella-modelli table th:first-child {
  width: calc(100% / 30);
}
table tbody th {
  font-weight: 300;
}
.tabella-modelli table tbody tr {
  border-bottom: 1px solid #c5c0b7;
}
.tabella-modelli span {
  font-size: 12px;
  line-height: 12px;
  font-weight: 400;
}
input[type="radio"],
input[type="checkbox"] {
  border: 1px solid #000;
  padding: 0.5em;
  -webkit-appearance: none;
}
input[type="radio"]:checked,
input[type="checkbox"]:checked {
  background: #acacac;
  background-size: 9px 9px;
}
.misure-tab-accessorio span {
  font-size: 12px;
  font-weight: 300;
  margin: 0 0 0 10px;
}
.image-articolo {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 50%;
}
.articolo-box {
  width: 50%;
}
.recap-info {
  width: 100%;
}
.recap-info > div {
  width: calc(100% / 5);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
}
.colori {
  display: flex;
  padding: 1em 0;
  border-bottom: 1px solid #dedfd9;
}
.color-box {
  width: calc(100% / 4);
  padding: 10px;
  transition: all 0.3s;
  cursor: pointer;
}
.color-box:hover {
  transform: scale(1.04);
}
.color-active {
  background-color: #ddd;
}
.color-block {
  cursor: not-allowed;
}
.freccia img {
  position: relative;
  top: -1px;
}
.title-accessori {
  border-bottom: 1px solid #dedfd9;
}
.accessorio {
  width: 100%;
}
.accessorio table th {
  padding: 10px 5px 10px 5px;
}
.accessorio table tr {
  border-bottom: 1px solid #dedfd9;
}
.accessorio table thead tr {
  background-color: #f2f3f3;
}
.menu-space {
  padding-top: 20px;
}
.color-opacity {
  opacity: 0.3;
}
.box-illuminabile {
  width: calc(100% / 4);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 20px 10px;
}
.lista-accessori {
  flex-direction: column;
}
@media (max-width: 1024px) {
  .colori {
    flex-wrap: wrap;
  }
  .box-image-dati {
    flex-direction: column;
  }
  .tabella-modelli table {
    min-width: 936px;
  }
  .tabella-modelli {
    overflow: auto;
  }
  .image-articolo,
  .articolo-box {
    width: 100%;
  }
  .recap-info > div {
    width: calc(100% / 4);
  }
  .accessorio {
    width: 100%;
  }
  .accessorio > div {
    flex-direction: column;
  }
  .box-accessorio-image,
  .box-accessorio-table {
    width: 100%;
  }
  .lista-accessori {
    flex-direction: column;
  }
  .side-image {
    width: 100%;
    height: auto;
  }
  .side-image-in {
    height: auto;
  }
  .case-image {
    width: calc(100% / 3);
  }
  .swiper {
    padding-bottom: 50px;
  }
  .swiper-slide {
    flex-direction: column;
  }
  .swiper-sx {
    width: 100%;
    display: flex;
    justify-content: center;
  }
  .swiper-dx {
    width: 100%;
  }
  .swiper-button-next,
  .swiper-button-prev {
    top: 98%;
  }
  .swiper-button-prev {
    left: 0;
  }
  .content-slide {
    left: 0;
    text-align: center;
    padding-top: 20px;
  }
  .swiper-pagination {
    left: 0;
    top: 96%;
  }
  .box-illuminabile {
    width: calc(100% / 3);
  }
}
@media (max-width: 550px) {
  .color-box {
    width: calc(100% / 2);
  }
  .configura {
    text-align: center;
  }
  .case-image {
    width: calc(100% / 2);
  }
  .swiper-sx img {
    height: auto;
  }
  .box-illuminabile {
    width: calc(100% / 2);
  }
  .swiper-dx {
    justify-content: center;
  }
}

.leggi-box {
  max-height: 100px; /* Impostare la dimensione massima prima che si attivi l'espansione */
  overflow: hidden;
  transition: max-height 0.3s ease;
}
.expanded {
  max-height: none;
  overflow: visible;
}
.leggi-btn {
  border: none;
  padding: 4px;
  transition: all 0.3s;
  background: #dedede;
  color: #000;
}
.leggi-btn:hover{
  opacity: 0.7;
  color: #fff;
  background: #636363;
}
</style>
